module.exports = __webpack_public_path__ + "img/map.d1d039a4.png";